export const checkIfShouldDisableSaveButton = data => {
  const isAllFilled = data.every(
    question =>
      question.description &&
      question.choices.every(choice => choice) &&
      question.correctAnswerIndexes.length,
  )
  return !isAllFilled
}
